import { Injectable, inject } from '@angular/core';
import { HeaderService } from '@shared/services';
import { BehaviorSubject, delay, filter, Observable, switchMap } from 'rxjs';
import {
  FileParameter,
  FileResponse,
  GstarClient,
  SecurityFileImportResponse,
} from 'src/app/web-api-client';

@Injectable({
  providedIn: 'root',
})
export class ImportService {
  private readonly headerService = inject(HeaderService);
  private readonly gstarClient = inject(GstarClient);

  private checkFileImportStatusSubj: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  checkFileImportStatusObs: Observable<number> =
    this.checkFileImportStatusSubj.asObservable();

  fileImport: Observable<SecurityFileImportResponse> =
    this.checkFileImportStatusObs.pipe(
      filter(
        (fileImportId: number) => fileImportId !== null && fileImportId !== 0
      ),
      delay(1000), //Wait 1 second before checking status
      switchMap((fileImportId: number) =>
        this.gstarClient.securityfileimportsGET2(fileImportId)
      )
    );

  importExcel(request: FileParameter): Observable<SecurityFileImportResponse> {
    const clientId = this.headerService.selectedClient()?.id;

    return this.gstarClient.upload2(clientId, request);
  }

  downloadTemplate(): Observable<FileResponse> {
    return this.gstarClient.download4();
  }

  reloadFileImportStatus(fileImportId: number): void {
    this.checkFileImportStatusSubj.next(fileImportId);
  }
}
